<template lang="pug">
.tile.is-ancestor.is-vertical
  .tile.is-parent.is-4
    article.tile.is-child.box
      h1.title Select Endpoint
      .block
        .field
          label.label Endpoint
          .control
            .select
              select(v-model='endpoint.selection' v-on:change='setEndpoint')
                option(v-for='opt in api.options' :value='opt.name') {{opt.name}}
</template>

<script>
import { UPDATE_ENDPOINT } from 'vuex-store/mutation-types'
export default {
  data () {
    return {
      endpoint: {
        selection: ''
      }
    }
  },
  computed: {
    api () {
      return {
        options: this.$store.state.endpointOptions
      }
    }
  },
  mounted () {
    this.endpoint.selection = this.$store.state.endpoint
  },
  methods: {
    setEndpoint () {
      let selectedObject = this.api.options.find((i) => {
        return i.name === this.endpoint.selection
      })
      this.$store.commit(UPDATE_ENDPOINT, selectedObject.name)
      if (!this.$store.getters['auth/ok']) {
        this.$store.dispatch('auth/logout')
        this.$router.push('Home')
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// index.vue?92726606